import { AbstractControl } from '@angular/forms';

export function BudgetMinBidrag(control: AbstractControl) {
  if (control.value) {
    const parsedValue = JSON.parse(control.value);
    const anyNonZeroBidrag = parsedValue.projektparter.some((p) =>
      p.bidragPerAr.some((b) => b.summa > 0),
    );
    if (anyNonZeroBidrag) {
      return;
    }
  }

  return { BudgetMinBidrag: true };
}
